import { useEffect, useState } from 'react';

declare global {
  interface Window {
    Cookiebot?: {
      consent?: { marketing?: boolean };
      renew?: () => void;
    };
  }
}

const CONSENT_READY_EVENT = 'CookiebotOnConsentReady';

const getMarketingConsent = (): boolean =>
  typeof window !== 'undefined' && window.Cookiebot?.consent?.marketing === true;

const openCookieSettings = () => {
  window.Cookiebot?.renew?.();
};

/**
 * Keeps track of the visitor's Cookiebot marketing consent
 * and exposes a way to reopen the consent dialog.
 */
export const useCookiebotConsent = () => {
  const [hasMarketingConsent, setHasMarketingConsent] = useState(getMarketingConsent);

  useEffect(() => {
    const syncConsent = () => {
      setHasMarketingConsent(getMarketingConsent());
    };

    syncConsent();
    window.addEventListener(CONSENT_READY_EVENT, syncConsent);

    return () => {
      window.removeEventListener(CONSENT_READY_EVENT, syncConsent);
    };
  }, []);

  return { hasMarketingConsent, openCookieSettings };
};
